(function() {
	angular.module('main').controller('ReferController', ReferController);

	ReferController.$inject = [
		'$scope',
		'$http',
		'copyToClipboardService',
		'messageService'
	];

	function ReferController(
		$scope,
		$http,
		copyToClipboardService,
		messageService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isCopySpinnningWheelActive = false;
			getReferInfo();
		});

		function successGetReferInfo(data) {
			$scope.ambassadorPromoCode = data.ambassadorPromoCode;
			$scope.companyPromoCode = data.companyPromoCode;
			$scope.referrals = data.referrals;
			$scope.countAmbassadorReferrals = data.countAmbassadorReferrals;
			$scope.referText = `Hello friends! Use this promo code: ${
				$scope.companyPromoCode
			} and get $5 off your monthly subscription to the world\'s most user-friendly photography business software, Studio Ninja!`;
			$scope.ambassadorText = `Hello friends! Use this promo code: ${
				$scope.ambassadorPromoCode
			} and get 50% off your first year’s subscription to the world\'s most user-friendly photography business software, Studio Ninja!`;
		}

		$scope.isSafari =
			Object.prototype.toString
				.call(window.HTMLElement)
				.indexOf('Constructor') > 0;

		$scope.copy2Clipboard = (element, successMessage) => {
			$scope.isCopySpinnningWheelActive = true;
			copyToClipboardService.copy(element, successMessage);
			$scope.isCopySpinnningWheelActive = false;
		};

		$scope.referStatuses = {
			SUBSCRIBED: 'Subscribed! You get $5 off',
			EXPIRED: 'Expired',
			TRIAL: 'Trial user',
			NO_ACTION: 'No action'
		};

		$scope.referUsers = [];

		function getReferInfo() {
			$http({
				method: 'GET',
				url: '/protected/rest/settings/refer'
			})
				.then(result => successGetReferInfo(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		$scope.order = function(predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse =
					$scope.pageRequest.pageOrder.predicate === predicate
						? !$scope.pageRequest.pageOrder.reverse
						: false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.referrals = $filter('orderBy')(
				$scope.referrals,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/referController.js